import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import { Input, Space, Select } from 'antd';
import axios from "axios";
import configData from "../../config/config.json";
import { notifysuccess } from "../../utils/toast";
import { notifyfailure } from "../../utils/toast";
import { notifycatch } from "../../utils/toast";
import { TokenVerificationLoggedOut } from "../../utils/tokenVerify";
import constantData from "../../constants/constantData.json";
import loaderIcon from "../../assets/images/login-and-signup/loader.gif";
import 'swiper/css';
import { Link, useNavigate } from "react-router-dom";
import { setRegisterFlowData } from "../../utils/registerFlowStore";

import Logo from '../../assets/newlayout/logo.svg'

import NewLeftImgOne from '../../assets/newlayout/new_one/first_box/one.svg'
import NewLeftImgTwo from '../../assets/newlayout/new_one/first_box/two.svg'
import NewLeftImgThree from '../../assets/newlayout/new_one/first_box/three.svg'
import NewLeftImgFour from '../../assets/newlayout/new_one/first_box/four.svg'

import NewRightImgOne from '../../assets/newlayout/new_one/second_box/first.svg'
import NewRightImgTwo from '../../assets/newlayout/new_one/second_box/second.svg'
import NewRightImgThree from '../../assets/newlayout/new_one/second_box/third.svg'

import NewBottomLeftImgOne from '../../assets/newlayout/new_one/third_box/one.svg'
import NewBottomLeftImgTwo from '../../assets/newlayout/new_one/third_box/two.svg'
import NewBottomLeftImgThree from '../../assets/newlayout/new_one/third_box/three.svg'

import NewBottomRightImgOne from '../../assets/newlayout/new_one/four_box/one.svg'
import NewBottomRightImgTwo from '../../assets/newlayout/new_one/four_box/two.svg'
import NewBottomRightImgThree from '../../assets/newlayout/new_one/four_box/three.svg'

import SignUpText from '../../assets/newlayout/sign_up_text.svg'


const SignupV2 = () => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const buttonRef0 = useRef(null);

    const loginMoveRef = useRef(null)

    const scrollToItem = (ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    useEffect(() => {
        TokenVerificationLoggedOut();
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (!status) {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        const handleEnterKeyPress0 = (event) => {
            if (event.key === "Enter" && buttonRef0 && buttonRef0?.current) {
                buttonRef0?.current.click();
            }
        };
        document.addEventListener("keydown", handleEnterKeyPress0);
        return () => {
            document.removeEventListener("keydown", handleEnterKeyPress0);
        };
    }, []);


    //////////////////////////////////////////Register code ////////////////////////////////////////

    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const [companyName, setCompanyName] = useState("");
    const [companyNameIsRequiredError, setCompanyNameIsRequiredError] =
        useState(false);

    const [emailRegister, setEmailRegister] = useState("");
    const [emailRegisterIsRequiredError, setEmailRegisterIsRequiredError] = useState(false);
    const [emailRegisterUrlError, setEmailRegisterUrlError] = useState(false);

    const [companyWebsite, setCompanyWebsite] = useState("");
    const [companyWebsiteIsRequiredError, setCompanyWebsiteIsRequiredError] =
        useState(false);
    const [companyWebsiteUrlError, setCompanyWebsiteUrlError] = useState(false);

    const [im, setIm] = useState("");
    const [imIsRequiredError, setImIsRequiredError] = useState(false);

    const [selectedIm, setSelectedIm] = useState("telegram");

    const [buttonValue, setButtonValue] = useState(false);

    const validateWebsiteUrl = (websiteUrl) => {
        return String(websiteUrl)
            .toLowerCase()
            .match(/.+[.].+/);
    };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    function resetRegiterScreen() {
        setName("")
        setNameIsRequiredError(false)
        setCompanyName("")
        setCompanyNameIsRequiredError(false)
        setEmailRegister("")
        setEmailRegisterIsRequiredError(false)
        setEmailRegisterUrlError(false)
        setCompanyWebsite("")
        setCompanyWebsiteIsRequiredError(false)
        setCompanyWebsiteUrlError(false)
        setIm("")
        setImIsRequiredError(false)
        setSelectedIm("telegram")
        setButtonValue(false)
    }

    function onChangeName(event) {
        setNameIsRequiredError(false);
        setName(event.target.value);
    }

    function onBlurName(event) {
        if (event.target.value.trim().length === 0) {
            setNameIsRequiredError(true);
        }
        setName(event.target.value.trim());
    }

    function onChangeCompanyName(event) {
        setCompanyNameIsRequiredError(false);
        setCompanyName(event.target.value);
    }

    function onBlurCompanyName(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyNameIsRequiredError(true);
            setCompanyName("");
        }
        setCompanyName(event.target.value.trim());
    }

    function onChangeEmailRegister(event) {
        setEmailRegisterIsRequiredError(false);
        setEmailRegister(event.target.value);

        if (validateEmail(event.target.value) === null) {
            setEmailRegisterUrlError(true);
        } else {
            setEmailRegisterUrlError(false);
        }
    }

    function onBlurEmailRegister(event) {
        if (event.target.value.trim().length === 0) {
            setEmailRegisterUrlError(false);
            setEmailRegisterIsRequiredError(true);
        }
        else {
            if (validateEmail(event.target.value.trim()) === null) {
                setEmailRegisterUrlError(true);
            } else {
                setEmailRegisterUrlError(false);
            }
        }
        setEmailRegister(event.target.value.trim());
    }

    function onChangeIm(event) {
        setImIsRequiredError(false);
        setIm(event.target.value);
    }

    function onBlurIm(event) {
        if (event.target.value.trim().length === 0) {
            setImIsRequiredError(true);
        }
        setIm(event.target.value.trim())
    }

    function onChangeSelectedIm(event) {
        setSelectedIm(event);
    }

    function onChangeCompanyWebsite(event) {
        setCompanyWebsite(event.target.value);

        if (event.target.value.length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        } else {
            setCompanyWebsiteIsRequiredError(false);

            if (validateWebsiteUrl(event.target.value) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
    }

    function onBlurCompanyWebsite(event) {
        if (event.target.value.trim().length === 0) {
            setCompanyWebsiteUrlError(false);
            setCompanyWebsiteIsRequiredError(true);
        }
        else {
            if (validateWebsiteUrl(event.target.value.trim()) === null) {
                setCompanyWebsiteUrlError(true);
            } else {
                setCompanyWebsiteUrlError(false);
            }
        }
        setCompanyWebsite(event.target.value.trim());
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (
            name !== "" &&
            companyName !== "" &&
            emailRegister !== "" &&
            companyWebsite !== "" &&
            im !== ""
        ) {
            if (
                nameIsRequiredError === false &&
                companyNameIsRequiredError === false &&
                emailRegisterIsRequiredError === false &&
                emailRegisterUrlError === false &&
                companyWebsiteUrlError === false &&
                companyWebsiteIsRequiredError === false &&
                imIsRequiredError === false
            ) {
                let payload = {
                    p_name: name,
                    o_name: companyName,
                    email: emailRegister,
                    c_website: companyWebsite,
                    im: { "label": selectedIm, "value": im }
                };

                setButtonValue(true);
                scrollToItem(loginMoveRef)

                axios
                    .post(configData.SERVER_URL + "user/signup", payload)
                    .then((response) => {

                        notifysuccess(response.data.message);
                        setRegisterFlowData({
                            pubId: response.data.data._id,
                            signupData: response.data.data,
                        });
                        setTimeout(() => {
                            navigate("/signup-onboarding");
                        }, 800);



                    })
                    .catch((error) => {
                        if (error?.response) {
                            if (error?.response?.data?.message?.length !== 0) {
                                notifyfailure(error.response.data.message)
                            }
                        } else {
                            notifycatch()
                        }
                        setButtonValue(false);
                    });
            }
        } else {
            if (name === "") {
                setNameIsRequiredError(true);
            }
            if (companyName === "") {
                setCompanyNameIsRequiredError(true);
            }
            if (emailRegister === "") {
                setEmailRegisterIsRequiredError(true);
            }
            if (companyWebsite === "") {
                setCompanyWebsiteIsRequiredError(true);
            }
            if (im === "") {
                setImIsRequiredError(true);
            }
        }
    };


    if (loading) {
        return (
            <>
                <div className="fullscreen"></div>
            </>
        );
    } else {
        return (
            <div>

                <div className="new_sign_up_in_div --sign_up_div">
                    <div className="left">
                        <div className="new_left">
                            <ul>
                                <li>
                                    <img src={NewLeftImgOne} className="img-fluid" alt="" />
                                    <img src={NewLeftImgTwo} className="img-fluid" alt="" />
                                    <img src={NewLeftImgThree} className="img-fluid" alt="" />
                                    <img src={NewLeftImgFour} className="img-fluid" alt="" />
                                </li>
                                <li>
                                    <img src={NewRightImgOne} className="img-fluid" alt="" />
                                    <img src={NewRightImgTwo} className="img-fluid" alt="" />
                                    <img src={NewRightImgThree} className="img-fluid" alt="" />
                                </li>
                                <li>
                                    <img src={NewBottomLeftImgOne} className="img-fluid" alt="" />
                                    <img src={NewBottomLeftImgTwo} className="img-fluid" alt="" />
                                    <img src={NewBottomLeftImgThree} className="img-fluid" alt="" />
                                </li>
                                <li>
                                    <img src={NewBottomRightImgOne} className="img-fluid" alt="" />
                                    <img src={NewBottomRightImgTwo} className="img-fluid" alt="" />
                                    <img src={NewBottomRightImgThree} className="img-fluid" alt="" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="right">
                        <img src={Logo} className='img-fluid' alt="" />
                        <div className="login-box">
                            <img src={SignUpText} className='img-fluid' alt="" />
                            <p className='sing_up_para'>Please fill the details below to create a new account.</p>
                            <div className='sign_up_form_input_div'>
                                <div>
                                    <label htmlFor="">Publisher Name <span>*</span></label>
                                    <Input prefix={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M13.3337 14V12.6667C13.3337 11.9594 13.0527 11.2811 12.5526 10.781C12.0525 10.281 11.3742 10 10.667 10H5.33366C4.62641 10 3.94814 10.281 3.44804 10.781C2.94794 11.2811 2.66699 11.9594 2.66699 12.6667V14" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M7.99967 7.33333C9.47243 7.33333 10.6663 6.13943 10.6663 4.66667C10.6663 3.19391 9.47243 2 7.99967 2C6.52692 2 5.33301 3.19391 5.33301 4.66667C5.33301 6.13943 6.52692 7.33333 7.99967 7.33333Z" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    }
                                        className={
                                            nameIsRequiredError
                                                ? "error"
                                                : ""
                                        }
                                        placeholder="Enter your Name"
                                        value={name}
                                        onBlur={onBlurName}
                                        onChange={onChangeName}
                                        autocomplete="off"

                                    />
                                    <span className="error_content h_error">
                                        {nameIsRequiredError && (
                                            <> This field is required</>
                                        )}
                                    </span>
                                </div>
                                <div>
                                    <label htmlFor="">Organisation Name <span>*</span></label>
                                    <Input prefix={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M13.5 4.5H2.5C2.22386 4.5 2 4.72386 2 5V13C2 13.2761 2.22386 13.5 2.5 13.5H13.5C13.7761 13.5 14 13.2761 14 13V5C14 4.72386 13.7761 4.5 13.5 4.5Z" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M5.5 6.5V4.5C5.5 3.83696 5.76339 3.20107 6.23223 2.73223C6.70107 2.26339 7.33696 2 8 2C8.66304 2 9.29893 2.26339 9.76777 2.73223C10.2366 3.20107 10.5 3.83696 10.5 4.5V6.5" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    }

                                        className={
                                            companyNameIsRequiredError
                                                ? "error"
                                                : ""
                                        }
                                        placeholder="Enter Organisation Name"
                                        value={companyName}
                                        onBlur={onBlurCompanyName}
                                        onChange={onChangeCompanyName}
                                        autocomplete="off"
                                    />
                                    <span className="error_content h_error">
                                        {companyNameIsRequiredError && (
                                            <> This field is required</>
                                        )}
                                    </span>
                                </div>
                                <div>
                                    <label htmlFor="">Email Address <span>*</span></label>
                                    <Input prefix={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M7.99967 10.6663C9.47243 10.6663 10.6663 9.47243 10.6663 7.99967C10.6663 6.52692 9.47243 5.33301 7.99967 5.33301C6.52692 5.33301 5.33301 6.52692 5.33301 7.99967C5.33301 9.47243 6.52692 10.6663 7.99967 10.6663Z" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M10.6663 5.33357V8.6669C10.6663 9.19734 10.8771 9.70605 11.2521 10.0811C11.6272 10.4562 12.1359 10.6669 12.6663 10.6669C13.1968 10.6669 13.7055 10.4562 14.0806 10.0811C14.4556 9.70605 14.6663 9.19734 14.6663 8.6669V8.00024C14.6663 6.49559 14.1572 5.03522 13.2219 3.85659C12.2866 2.67796 10.98 1.85039 9.51477 1.50844C8.0495 1.16648 6.51164 1.33027 5.15125 1.97315C3.79086 2.61603 2.68795 3.70021 2.02185 5.04939C1.35576 6.39856 1.16566 7.9334 1.48246 9.40431C1.79926 10.8752 2.60433 12.1957 3.76677 13.1511C4.9292 14.1064 6.38064 14.6405 7.88506 14.6663C9.38948 14.6922 10.8584 14.2084 12.053 13.2936" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    }

                                        className={
                                            (emailRegisterIsRequiredError || emailRegisterUrlError)
                                                ? "error"
                                                : ""
                                        }
                                        placeholder="example@gmail.com"
                                        value={emailRegister}
                                        onBlur={onBlurEmailRegister}
                                        onChange={onChangeEmailRegister}
                                        autocomplete="off"
                                    />
                                    <span className="error_content h_error">
                                        {emailRegisterIsRequiredError && (
                                            <> This field is required</>
                                        )}
                                        {emailRegisterUrlError && (
                                            <> Invalid Email Address</>
                                        )}
                                    </span>
                                </div>
                                <div>
                                    <label htmlFor="">Company website <span>*</span></label>
                                    <Input prefix={
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path d="M6.66699 8.66697C6.95329 9.04972 7.31856 9.36642 7.73803 9.5956C8.15749 9.82477 8.62133 9.96105 9.09809 9.99519C9.57485 10.0293 10.0534 9.96055 10.5012 9.79349C10.9491 9.62643 11.3557 9.36502 11.6937 9.02697L13.6937 7.02697C14.3009 6.3983 14.6368 5.55629 14.6292 4.6823C14.6216 3.80831 14.2711 2.97227 13.6531 2.35424C13.035 1.73621 12.199 1.38565 11.325 1.37806C10.451 1.37046 9.609 1.70644 8.98033 2.31364L7.83366 3.45364" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M9.33347 7.33381C9.04716 6.95106 8.68189 6.63435 8.26243 6.40518C7.84297 6.17601 7.37913 6.03973 6.90237 6.00559C6.4256 5.97144 5.94707 6.04023 5.49924 6.20729C5.0514 6.37435 4.64472 6.63576 4.3068 6.97381L2.3068 8.97381C1.69961 9.60248 1.36363 10.4445 1.37122 11.3185C1.37881 12.1925 1.72938 13.0285 2.3474 13.6465C2.96543 14.2646 3.80147 14.6151 4.67546 14.6227C5.54945 14.6303 6.39146 14.2943 7.02013 13.6871L8.16013 12.5471" stroke="#94A3B8" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    }

                                        className={
                                            (companyWebsiteIsRequiredError || companyWebsiteUrlError)
                                                ? "error"
                                                : ""
                                        }
                                        placeholder="Enter Company website"
                                        value={companyWebsite}
                                        onBlur={onBlurCompanyWebsite}
                                        onChange={onChangeCompanyWebsite}
                                        autocomplete="off"
                                    />
                                    <span className="error_content h_error">
                                        {companyWebsiteIsRequiredError && (
                                            <> This field is required</>
                                        )}
                                        {companyWebsiteUrlError && (
                                            <>Invalid Website Url</>
                                        )}
                                    </span>
                                </div>
                                <div className='compact_div'>
                                    <label htmlFor="">IM <span>*</span></label>
                                    <Space.Compact className={
                                        imIsRequiredError
                                            ? "form_compact error"
                                            : "form_compact"
                                    }>
                                        <Select
                                            className="form_select"
                                            popupMatchSelectWidth={true}
                                            suffixIcon={
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M5 7.5L10 12.5L15 7.5" stroke="#64748B" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            }
                                            value={selectedIm}
                                            onChange={onChangeSelectedIm}
                                            options={constantData.IM_OPTIONS}
                                        />
                                        <Input
                                            placeholder="Username"
                                            className="form_control"
                                            value={im}
                                            onChange={onChangeIm}
                                            onBlur={onBlurIm}
                                            autocomplete="off"
                                        />
                                    </Space.Compact>

                                    <span className="error_content h_error">
                                        {imIsRequiredError && (
                                            <> This field is required</>
                                        )}

                                    </span>
                                </div>
                            </div>

                            {buttonValue &&

                                <button className="btn_primary btn loader">
                                    <span>Sign up</span>
                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>

                            }

                            {!buttonValue &&
                                <button className='btn_primary btn'
                                    ref={buttonRef0}
                                    onClick={handleSubmit}
                                >
                                    <span>Sign up</span>
                                    <img src={loaderIcon} alt='USP' className='loader_icon' />
                                </button>
                            }
                            <p>Already have an account?
                                {buttonValue ?
                                    <span className="primary ms-1">Login</span>
                                    :
                                    <Link to="/login" className='primary ms-1'
                                        style={{ textDecoration: "underline", cursor: "pointer" }}
                                    >Login</Link>
                                }
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default SignupV2
